// Real course content: 3 tracks, each with modules that map 1:1 onto the
// exam domains already defined in EXAMS (src/data.js) — same domain names,
// descriptions and article associations, so a module's validation quiz and
// its matching Certif domain practice draw from the exact same quiz bank
// entry (see quizBank.js's domainId = `${courseId}:${moduleIdx}`, which
// lines up with EXAMS[courseId].domains[moduleIdx]).
//
// A lesson is { n, title, kind, dur, link } — link is an ARTICLES id (or
// omitted where no article fits closely); this is the exact shape
// useNetdoc.js's `lessonsData` already used before this file existed.

export const COURSES = [
  {
    id: "encor",
    label: "CCNP Enterprise — ENCOR",
    exam: "CCNP ENCOR 350-401",
    modules: [
      {
        title: "Architecture", desc: "Campus, haute disponibilité, virtualisation.",
        prereq: "Aucun", duration: "55 min",
        lessons: [
          { n: 1, title: "Trunks 802.1Q et VLAN natif", kind: "Lecture", dur: "15 min", link: "vlan-trunk" },
          { n: 2, title: "Plan d'adressage et agrégation", kind: "Lecture", dur: "18 min", link: "subnetting" },
          { n: 3, title: "Haute disponibilité de couche 2/3", kind: "Lecture + schéma", dur: "22 min", link: "vlan-trunk" },
        ],
      },
      {
        title: "Virtualisation", desc: "VRF, GRE, overlays.",
        prereq: "Architecture", duration: "55 min",
        lessons: [
          { n: 1, title: "EVPN-VXLAN : plan de contrôle et VTEP", kind: "Lecture", dur: "20 min", link: "vxlan" },
          { n: 2, title: "VRF et cloisonnement de routage", kind: "Lecture", dur: "16 min", link: "redistribution" },
          { n: 3, title: "Overlays et tunnels : ce qu'on encapsule", kind: "Lecture + schéma", dur: "19 min", link: "vxlan" },
        ],
      },
      {
        title: "Infrastructure", desc: "Concevoir un IGP qui converge, contrôler la redistribution et documenter ses politiques.",
        prereq: "OSPF fondamentaux", duration: "3 h 20",
        lessons: [
          { n: 1, title: "Rappels : métriques et distances administratives", kind: "Lecture", dur: "18 min", link: "bgp-attrs" },
          { n: 2, title: "OSPF multi-aires : conception et LSA", kind: "Lecture + schéma", dur: "32 min", link: "ospf-lsa" },
          { n: 3, title: "IS-IS : niveaux et adjacences", kind: "Lecture", dur: "26 min", link: "ospf-lsa" },
          { n: 4, title: "Redistribution sans boucle : tags et filtres", kind: "Lecture + atelier CLI", dur: "40 min", link: "redistribution" },
          { n: 5, title: "Route-maps et prefix-lists en pratique", kind: "Atelier CLI", dur: "35 min", link: "redistribution" },
          { n: 6, title: "BGP : politiques de sortie", kind: "Lecture", dur: "28 min", link: "bgp-attrs" },
          { n: 7, title: "Convergence : mesurer et améliorer", kind: "Lecture", dur: "41 min", link: "bgp-attrs" },
        ],
      },
      {
        title: "Assurance réseau", desc: "Diagnostic, telemetry, journalisation.",
        prereq: "Infrastructure", duration: "51 min",
        lessons: [
          { n: 1, title: "Lire un show bgp summary en incident", kind: "Atelier CLI", dur: "20 min", link: "bgp-attrs" },
          { n: 2, title: "Journaliser une décision de bestpath", kind: "Lecture", dur: "14 min", link: "bgp-attrs" },
          { n: 3, title: "Telemetry : ce qu'il faut instrumenter", kind: "Lecture", dur: "17 min", link: "bgp-attrs" },
        ],
      },
      {
        title: "Sécurité", desc: "Contrôle d'accès, plan de contrôle.",
        prereq: "Architecture", duration: "54 min",
        lessons: [
          { n: 1, title: "IKEv2 : phases et propositions", kind: "Lecture", dur: "18 min", link: "ipsec" },
          { n: 2, title: "Dépanner un tunnel qui ne monte pas", kind: "Atelier CLI", dur: "24 min", link: "ipsec" },
          { n: 3, title: "NAT-T et durées de vie asymétriques", kind: "Lecture", dur: "12 min", link: "ipsec" },
        ],
      },
      {
        title: "Automatisation", desc: "Python, JSON, Ansible, API.",
        prereq: "Aucun", duration: "80 min",
        lessons: [
          { n: 1, title: "Inventaire et connexion network_cli", kind: "Lecture", dur: "16 min", link: "ansible" },
          { n: 2, title: "Modules d'état et idempotence", kind: "Lecture + atelier CLI", dur: "28 min", link: "ansible" },
          { n: 3, title: "check_mode et diff avant application", kind: "Atelier CLI", dur: "22 min", link: "ansible" },
          { n: 4, title: "Vault : ne jamais stocker un secret en clair", kind: "Lecture", dur: "14 min", link: "ansible" },
        ],
      },
    ],
  },
  {
    id: "jncia",
    label: "JNCIA-Junos",
    exam: "JNCIA-Junos JN0-105",
    modules: [
      {
        title: "Fondamentaux Junos", desc: "Architecture, plan de contrôle.",
        prereq: "Aucun", duration: "49 min",
        lessons: [
          { n: 1, title: "Architecture Junos : plans séparés", kind: "Lecture", dur: "15 min", link: "ospf-lsa" },
          { n: 2, title: "Base de données OSPF sous Junos", kind: "Atelier CLI", dur: "18 min", link: "ospf-lsa" },
          { n: 3, title: "Types de LSA et propagation", kind: "Lecture", dur: "16 min", link: "ospf-lsa" },
        ],
      },
      {
        title: "Interface utilisateur", desc: "CLI, hiérarchie, commit.",
        prereq: "Fondamentaux Junos", duration: "50 min",
        lessons: [
          { n: 1, title: "Hiérarchie de configuration Junos", kind: "Lecture", dur: "14 min", link: "subnetting" },
          { n: 2, title: "commit, rollback et confirmed", kind: "Lecture + atelier CLI", dur: "20 min", link: "subnetting" },
          { n: 3, title: "Plan d'adressage documenté", kind: "Atelier CLI", dur: "16 min", link: "subnetting" },
        ],
      },
      {
        title: "Configuration initiale", desc: "Interfaces, services.",
        prereq: "Interface utilisateur", duration: "47 min",
        lessons: [
          { n: 1, title: "Interfaces et unités logiques", kind: "Lecture", dur: "15 min", link: "vlan-trunk" },
          { n: 2, title: "VLAN et ethernet-switching", kind: "Atelier CLI", dur: "19 min", link: "vlan-trunk" },
          { n: 3, title: "Services de base : NTP, syslog, SNMP", kind: "Lecture", dur: "13 min", link: "vlan-trunk" },
        ],
      },
      {
        title: "Routage et politiques", desc: "Tables, policy-statement.",
        prereq: "Configuration initiale", duration: "74 min",
        lessons: [
          { n: 1, title: "policy-statement : from / then", kind: "Lecture", dur: "17 min", link: "redistribution" },
          { n: 2, title: "Redistribution sans boucle sous Junos", kind: "Atelier CLI", dur: "22 min", link: "redistribution" },
          { n: 3, title: "BGP sous Junos : show route receive-protocol", kind: "Atelier CLI", dur: "20 min", link: "bgp-attrs" },
          { n: 4, title: "Comparer bestpath IOS-XE et Junos", kind: "Lecture", dur: "15 min", link: "bgp-attrs" },
        ],
      },
      {
        title: "Surveillance", desc: "Journaux, traceoptions.",
        prereq: "Routage et politiques", duration: "46 min",
        lessons: [
          { n: 1, title: "traceoptions : cibler sans noyer les logs", kind: "Lecture", dur: "16 min", link: "ipsec" },
          { n: 2, title: "SA IPsec sous Junos", kind: "Atelier CLI", dur: "18 min", link: "ipsec" },
          { n: 3, title: "Journalisation structurée et rétention", kind: "Lecture", dur: "12 min", link: "ipsec" },
        ],
      },
    ],
  },
  {
    id: "auto",
    label: "Automatisation réseau",
    exam: null,
    modules: [
      {
        title: "Inventaire et sources de vérité", desc: "YAML, IPAM, dynamique.",
        prereq: "Aucun", duration: "66 min",
        lessons: [
          { n: 1, title: "Inventaire statique vs dynamique", kind: "Lecture", dur: "15 min", link: "ansible" },
          { n: 2, title: "IPAM comme source de vérité", kind: "Lecture", dur: "17 min", link: "subnetting" },
          { n: 3, title: "network_cli et group_vars", kind: "Atelier CLI", dur: "20 min", link: "ansible" },
          { n: 4, title: "Découper l'inventaire par site", kind: "Lecture", dur: "14 min", link: "subnetting" },
        ],
      },
      {
        title: "Idempotence", desc: "check_mode, diff, tests.",
        prereq: "Inventaire et sources de vérité", duration: "52 min",
        lessons: [
          { n: 1, title: "Qu'est-ce qu'un module idempotent", kind: "Lecture", dur: "14 min", link: "ansible" },
          { n: 2, title: "check_mode et --diff en pratique", kind: "Atelier CLI", dur: "22 min", link: "ansible" },
          { n: 3, title: "Modules *_config et leurs pièges", kind: "Lecture", dur: "16 min", link: "ansible" },
        ],
      },
      {
        title: "Modèles de configuration", desc: "Jinja2, variables de site.",
        prereq: "Idempotence", duration: "49 min",
        lessons: [
          { n: 1, title: "Jinja2 : variables et boucles", kind: "Lecture", dur: "16 min", link: "vlan-trunk" },
          { n: 2, title: "Templates de VLAN par site", kind: "Atelier CLI", dur: "20 min", link: "vlan-trunk" },
          { n: 3, title: "Éviter la dérive de configuration", kind: "Lecture", dur: "13 min", link: "vlan-trunk" },
        ],
      },
      {
        title: "Vérification d'intention", desc: "Assertions après application.",
        prereq: "Modèles de configuration", duration: "47 min",
        lessons: [
          { n: 1, title: "Vérifier l'état attendu après application", kind: "Lecture", dur: "15 min", link: "bgp-attrs" },
          { n: 2, title: "Assertions sur un show bgp summary", kind: "Atelier CLI", dur: "20 min", link: "bgp-attrs" },
          { n: 3, title: "De l'exécution à la preuve", kind: "Lecture", dur: "12 min", link: "bgp-attrs" },
        ],
      },
      {
        title: "Secrets", desc: "Vault, rotation.",
        prereq: "Aucun", duration: "42 min",
        lessons: [
          { n: 1, title: "Vault : chiffrer au repos", kind: "Lecture", dur: "14 min", link: "ipsec" },
          { n: 2, title: "Rotation de secrets sans coupure", kind: "Lecture", dur: "16 min", link: "ipsec" },
          { n: 3, title: "Ne jamais logguer un secret", kind: "Atelier CLI", dur: "12 min", link: "ipsec" },
        ],
      },
    ],
  },
];
